<template>
  <div class="situation-warp" :class="{ show: congestDataList.length }">
    <van-row
      type="flex"
      justify="space-between"
      gutter="16"
      style="align-items: center"
    >
      <van-col class="situation-warp-title">拥堵实况</van-col>
      <van-col v-if="updateTime" class="situation-update-time">
        更新于<span>{{ time }}</span>
      </van-col>
    </van-row>
    <!-- 地图 -->
    <van-row type="flex" justify="space-between" gutter="16" v-if="showMap">
      <div class="map-container">
        <!-- 地图容器 -->
        <CardMap :city="fitViewCity" :fit-view-priority="fitViewPriority">
          <CongestSmallMarkerLayer
            :list="congestDataList"
            :auto-fit-view="FIT_VIEW_PRIORITY.FIRST_PANEL"
          />
          <TrafficLayer />
        </CardMap>
        <!-- 覆层，覆盖在地图上面，点击直接进入预警 -->
        <div class="map-mask" @click="goEarlyWarningLink" />
      </div>
    </van-row>
    <van-row v-if="areaType === 0" type="flex" class="situation-info">
      <van-col class="situation-info-idx" @click="goSituationLink(4)">
        <div
          class="font-num-Bd info-idx"
          :style="{
            color:
              congestStyle && congestStyle.length > 0
                ? congestStyle[0].color
                : '',
          }"
        >
          <span>{{ congestIndex }}</span>
          <i
            class="iconfont"
            :style="{
              color:
                trendIcon && trendIcon.iconColor ? trendIcon.iconColor : '',
            }"
            :class="trendIcon ? trendIcon.iconClass : ''"
          />
        </div>
        <div class="info-idx-text">拥堵指数</div>
      </van-col>
      <van-col class="situation-info-point" @click="goEarlyWarningLink()">
        <div class="font-num-Bd info-point">
          {{ congestDataList.length || 0 }}
        </div>
        <div>异常堵点</div>
      </van-col>
    </van-row>
    <van-row v-if="areaType === 1" type="flex" class="situation-info">
      <van-col
        class="situation-info-mileage"
        span="8"
        @click="goSituationLink(8)"
      >
        <div class="font-num-Bd info-mileage">
          <span>{{ congestHighWayTotalLength }}</span>
          <i
            class="iconfont"
            :style="{
              color:
                MileageIcon && MileageIcon.iconColor
                  ? MileageIcon.iconColor
                  : '',
            }"
            :class="MileageIcon ? MileageIcon.iconClass : ''"
          />
        </div>
        <div class="">拥堵里程({{ disUnit }})</div>
      </van-col>
      <van-col
        class="situation-info-station"
        span="8"
        @click="goSituationLink(10)"
      >
        <div class="font-num-Bd info-station">
          {{ realTimeData.congestTollNum || 0 }}
        </div>
        <div>拥堵收费站</div>
      </van-col>
      <van-col
        class="situation-info-wall"
        span="8"
        @click="goEarlyWarningLink()"
      >
        <div class="font-num-Bd info-wall">
          {{ congestDataList.length || 0 }}
        </div>
        <div>异常堵点</div>
      </van-col>
    </van-row>
    <van-row v-if="areaType === 2" type="flex" class="situation-info">
      <van-col class="situation-info-idx" @click="goSituationLink(4)">
        <div
          class="font-num-Bd info-idx"
          :style="{
            color:
              congestStyle && congestStyle.length > 0
                ? congestStyle[0].color
                : '',
          }"
        >
          <span>{{ congestIndex }}</span>
          <i
            class="iconfont"
            :style="{
              color:
                trendIcon && trendIcon.iconColor ? trendIcon.iconColor : '',
            }"
            :class="trendIcon ? trendIcon.iconClass : ''"
          />
        </div>
        <div class="info-idx-text">拥堵指数</div>
      </van-col>
      <van-col class="situation-info-point" @click="goEarlyWarningLink()">
        <div class="font-num-Bd info-point">
          {{ congestDataList.length || 0 }}
        </div>
        <div>异常堵点</div>
      </van-col>
      <van-col
        class="situation-info-mileage situation-info-mileage-other"
        @click="goSituationLink(8)"
      >
        <div class="font-num-Bd info-mileage">
          <span>{{ congestHighWayTotalLength }}</span>
          <i
            class="iconfont"
            :style="{
              color:
                MileageIcon && MileageIcon.iconColor
                  ? MileageIcon.iconColor
                  : '',
            }"
            :class="MileageIcon ? MileageIcon.iconClass : ''"
          />
        </div>
        <div class="">拥堵里程({{ disUnit }})</div>
      </van-col>
      <van-col
        class="situation-info-station situation-info-station-other"
        @click="goSituationLink(10)"
      >
        <div class="font-num-Bd info-station">
          {{ realTimeData.congestTollNum || 0 }}
        </div>
        <div>拥堵收费站</div>
      </van-col>
    </van-row>
    <van-row type="flex">
      <!-- 如果最后一行只有一项，则这一项将整行占满 -->
      <van-col
        v-for="(item, i) in congestionCards"
        :key="i"
        :span="
          i === congestionCards.length - 1 && congestionCards.length % 2 === 1
            ? 24
            : 12
        "
        class="congestion-item"
        @click="goSituationLink(item.linksType)"
      >
        <CongestionCard :card-data="item" />
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { webviewInfo, log } from '@ali/amap-lib';
import moment from 'moment';
import CongestionCard from './CongestionCard.vue';
import CardMap from './CardMap.vue';
import CongestionUtils from '../utils/CongestionUtils';
import NumberBeautify from '../utils/NumberBeautify';
import { FIT_VIEW_PRIORITY } from '../consts/mapFitViewPriority';
import jumpHandler from '../../../../../common/js/jump-handler';

export default {
  name: 'CongestionSituation', // 拥堵实况
  components: {
    CardMap,
    CongestionCard
  },
  props: {
    cityAdcode: {
      type: String,
      required: true
    },
    updateTime: {
      type: Number,
      default: () => null
    },
    realTimeData: {
      type: Object,
      default: () => null
    },
    congestDataList: {
      type: Array,
      required: true
    },
    congestDataInited: {
      type: Boolean,
      required: true
    },
    areaType: {
      type: Number,
      default: () => null // 0-城市， 1-高速
    },
    unitId: {
      type: Number,
      default: () => null
    },
    logParams: {
      type: Object,
      default: () => {}
    },
    showMap: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      FIT_VIEW_PRIORITY,
      fitViewPriority: 0,
      fitViewCity: '',
      congestIndex: null, // 指数
      congestStyle: null, // 指数色值
      congestHighWayTotalLength: null, // 里程
      congestionCards: [],
      areaCard: {}, // 区域
      tradeCard: {}, // 商圈
      roadCards: {}, // 路段
      scenicCard: {}, // 景区
      highCard: {}, // 高速
      stationCard: {}, // 收费站
      trendIcon: null, // 指数图标
      MileageIcon: {}, // 里程图标
      time: null,
      disUnit: null
    };
  },
  computed: {},
  watch: {
    realTimeData: {
      immediate: true,
      handler() {
        if (this.realTimeData) {
          this.getcongestionCards();
        }
      }
    },
    updateTime: {
      immediate: true,
      async handler(val, olVal) {
        console.log(val, olVal);
        if (val) {
          this.time = moment(val * 1000).format('HH:mm');
        }
      }
    },
    congestDataList: {
      immediate: true,
      async handler(nextValue) {
        if (this.congestDataInited) {
          // 只有高速账号才会作区分，城市账号直接展示city
          if (this.areaType === 1 && Array.isArray(nextValue) && nextValue.length > 3) {
            this.fitViewPriority = FIT_VIEW_PRIORITY.FIRST_PANEL;
            this.fitViewCity = '';
          } else {
            this.fitViewPriority = 0;
            this.fitViewCity = this.cityAdcode;
          }
        }
      }
    }
  },
  methods: {
    getcongestionCards() {
      if (this.areaType === 0) {
        if (this.realTimeData.congestIndex) {
          this.congestIndex = NumberBeautify.preciseNum(this.realTimeData.congestIndex, 2);
          const level = CongestionUtils.regionalCongestionLevel(this.congestIndex);
          this.congestStyle = CongestionUtils.getCongestionColor(level);
          if (this.realTimeData.historyCongestIndex) {
            this.trendIcon = CongestionUtils.getIdxTrendIcon(
              this.realTimeData.congestIndex,
              this.realTimeData.historyCongestIndex
            );
          } else {
            this.trendIcon = null;
          }
        } else {
          this.congestIndex = '-';
          this.trendIcon = {};
        }
        if (this.realTimeData.congestArea && this.realTimeData.congestAreaIndex) {
          if (this.realTimeData.congestAreaIndex >= 1.5) {
            const level = CongestionUtils.regionalCongestionLevel(
              this.realTimeData.congestAreaIndex
            );
            const status = CongestionUtils.getCongestionColor(level);
            this.areaCard = {
              cardName: '区域',
              cardArea: this.realTimeData.congestArea,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 4
            };
          } else {
            this.areaCard = {
              cardName: '区域',
              cardArea: '暂无拥堵',
              linksType: 4
            };
          }
        } else {
          this.areaCard = {
            cardName: '区域',
            cardArea: '—',
            linksType: 4
          };
        }
        if (this.realTimeData.congestBusiness && this.realTimeData.congestBusinessIndex) {
          if (this.realTimeData.congestBusinessIndex >= 1.5) {
            const level = CongestionUtils.regionalCongestionLevel(
              this.realTimeData.congestBusinessIndex
            );
            const status = CongestionUtils.getCongestionColor(level);
            this.tradeCard = {
              cardName: '商圈',
              cardArea: this.realTimeData.congestBusiness,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 3
            };
          } else {
            this.tradeCard = {
              cardName: '商圈',
              cardArea: '暂无拥堵',
              linksType: 3
            };
          }
        } else {
          this.tradeCard = {};
        }
        if (this.realTimeData.congestRoad && this.realTimeData.congestRoadIndex) {
          if (this.realTimeData.congestRoadIndex >= 1.8) {
            const level = CongestionUtils.roadCongestionLevel(this.realTimeData.congestRoadIndex);
            const status = CongestionUtils.getCongestionColor(level);
            this.roadCards = {
              cardName: '路段',
              cardArea: this.realTimeData.congestRoad,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 2
            };
          } else {
            this.roadCards = {
              cardName: '路段',
              cardArea: '暂无拥堵',
              linksType: 2
            };
          }
        } else {
          this.roadCards = {
            cardName: '路段',
            cardArea: '—',
            linksType: 2
          };
        }
        if (this.realTimeData.congestScene && this.realTimeData.congestSceneIndex) {
          if (this.realTimeData.congestSceneIndex >= 1.5) {
            const level = CongestionUtils.regionalCongestionLevel(
              this.realTimeData.congestSceneIndex
            );
            const status = CongestionUtils.getCongestionColor(level);
            this.scenicCard = {
              cardName: '景区',
              cardArea: this.realTimeData.congestScene,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 41
            };
          } else {
            this.scenicCard = {
              cardName: '景区',
              cardArea: '暂无拥堵',
              linksType: 41
            };
          }
        } else {
          this.scenicCard = {
            cardName: '景区',
            cardArea: '—',
            linksType: 41
          };
        }
        this.congestionCards = [
          this.areaCard,
          this.roadCards,
          this.scenicCard,
          this.tradeCard
        ].filter((item) => Object.keys(item).length > 0);
      } else if (this.areaType === 1) {
        if (this.realTimeData.congestHighWayTotalLength) {
          this.congestHighWayTotalLength = CongestionUtils.distanceNum(
            this.realTimeData.congestHighWayTotalLength
          );

          this.disUnit = this.realTimeData.congestHighWayTotalLength < 1000 ? 'm' : 'km';
          if (this.realTimeData.historyCongestHighWayTotalLength) {
            this.MileageIcon = CongestionUtils.getMileageIcon(
              this.realTimeData.congestHighWayTotalLength,
              this.realTimeData.historyCongestHighWayTotalLength
            );
          } else {
            this.MileageIcon = null;
          }
        } else {
          this.trendIcon = {};
          this.congestHighWayTotalLength = 0;
          this.disUnit = 'm';
        }
        if (this.realTimeData.congestHighWayName && this.realTimeData.congestHighWayLength) {
          this.highCard = {
            cardName: '高速',
            cardArea: this.realTimeData.congestHighWayName,
            desc: CongestionUtils.distanceBeautifyNum(
              this.realTimeData.congestHighWayLength,
              'm',
              true
            ),
            color: '#415886',
            bgColor: '#f2f2f2',
            linksType: 8
          };
        } else {
          this.highCard = {
            cardName: '高速',
            cardArea: this.realTimeData.congestHighWayLength === 0 ? '暂无拥堵' : '—',
            linksType: 8
          };
        }
        if (this.realTimeData.congestTollName && this.realTimeData.congestTolllLength) {
          this.stationCard = {
            cardName: '收费站',
            cardArea: this.realTimeData.congestTollName,
            desc: CongestionUtils.distanceBeautifyNum(
              this.realTimeData.congestTolllLength,
              'm',
              true
            ),
            color: '#415886',
            bgColor: '#f2f2f2',
            linksType: 10
          };
        } else {
          this.stationCard = {};
        }
        this.congestionCards = [this.highCard, this.stationCard].filter(
          (item) => Object.keys(item).length > 0
        );
      } else if (this.areaType === 2) {
        if (this.realTimeData.congestIndex) {
          this.congestIndex = NumberBeautify.preciseNum(this.realTimeData.congestIndex, 2);
          const level = CongestionUtils.regionalCongestionLevel(this.congestIndex);
          this.congestStyle = CongestionUtils.getCongestionColor(level);
          if (this.realTimeData.historyCongestIndex) {
            this.trendIcon = CongestionUtils.getIdxTrendIcon(
              this.realTimeData.congestIndex,
              this.realTimeData.historyCongestIndex
            );
          } else {
            this.trendIcon = null;
          }
        } else {
          this.congestIndex = '-';
          this.trendIcon = {};
        }
        if (this.realTimeData.congestArea && this.realTimeData.congestAreaIndex) {
          if (this.realTimeData.congestAreaIndex >= 1.5) {
            const level = CongestionUtils.regionalCongestionLevel(
              this.realTimeData.congestAreaIndex
            );
            const status = CongestionUtils.getCongestionColor(level);
            this.areaCard = {
              cardName: '区域',
              cardArea: this.realTimeData.congestArea,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 4
            };
          } else {
            this.areaCard = {
              cardName: '区域',
              cardArea: '暂无拥堵',
              linksType: 4
            };
          }
        } else {
          this.areaCard = {
            cardName: '区域',
            cardArea: '—',
            linksType: 4
          };
        }
        if (this.realTimeData.congestBusiness && this.realTimeData.congestBusinessIndex) {
          if (this.realTimeData.congestBusinessIndex >= 1.5) {
            const level = CongestionUtils.regionalCongestionLevel(
              this.realTimeData.congestBusinessIndex
            );
            const status = CongestionUtils.getCongestionColor(level);
            this.tradeCard = {
              cardName: '商圈',
              cardArea: this.realTimeData.congestBusiness,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 3
            };
          } else {
            this.tradeCard = {
              cardName: '商圈',
              cardArea: '暂无拥堵',
              linksType: 3
            };
          }
        } else {
          this.tradeCard = {};
        }
        if (this.realTimeData.congestRoad && this.realTimeData.congestRoadIndex) {
          if (this.realTimeData.congestRoadIndex >= 1.8) {
            const level = CongestionUtils.roadCongestionLevel(this.realTimeData.congestRoadIndex);
            const status = CongestionUtils.getCongestionColor(level);
            this.roadCards = {
              cardName: '路段',
              cardArea: this.realTimeData.congestRoad,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 2
            };
          } else {
            this.roadCards = {
              cardName: '路段',
              cardArea: '暂无拥堵',
              linksType: 2
            };
          }
        } else {
          this.roadCards = {
            cardName: '路段',
            cardArea: '—',
            linksType: 2
          };
        }
        if (this.realTimeData.congestScene && this.realTimeData.congestSceneIndex) {
          if (this.realTimeData.congestSceneIndex >= 1.5) {
            const level = CongestionUtils.regionalCongestionLevel(
              this.realTimeData.congestSceneIndex
            );
            const status = CongestionUtils.getCongestionColor(level);
            this.scenicCard = {
              cardName: '景区',
              cardArea: this.realTimeData.congestScene,
              desc: status[0].desc,
              color: status[0].color,
              bgColor: status[0].bgColor,
              linksType: 41
            };
          } else {
            this.scenicCard = {
              cardName: '景区',
              cardArea: '暂无拥堵',
              linksType: 41
            };
          }
        } else {
          this.scenicCard = {
            cardName: '景区',
            cardArea: '—',
            linksType: 41
          };
        }
        if (this.realTimeData.congestHighWayTotalLength) {
          this.congestHighWayTotalLength = CongestionUtils.distanceNum(
            this.realTimeData.congestHighWayTotalLength
          );

          this.disUnit = this.realTimeData.congestHighWayTotalLength < 1000 ? 'm' : 'km';
          if (this.realTimeData.historyCongestHighWayTotalLength) {
            this.MileageIcon = CongestionUtils.getMileageIcon(
              this.realTimeData.congestHighWayTotalLength,
              this.realTimeData.historyCongestHighWayTotalLength
            );
          } else {
            this.MileageIcon = null;
          }
        } else {
          this.trendIcon = {};
          this.congestHighWayTotalLength = 0;
          this.disUnit = 'm';
        }
        if (this.realTimeData.congestHighWayName && this.realTimeData.congestHighWayLength) {
          this.highCard = {
            cardName: '高速',
            cardArea: this.realTimeData.congestHighWayName,
            desc: CongestionUtils.distanceBeautifyNum(
              this.realTimeData.congestHighWayLength,
              'm',
              true
            ),
            color: '#415886',
            bgColor: '#f2f2f2',
            linksType: 8
          };
        } else {
          this.highCard = {
            cardName: '高速',
            cardArea: this.realTimeData.congestHighWayLength === 0 ? '暂无拥堵' : '—',
            linksType: 8
          };
        }
        if (this.realTimeData.congestTollName && this.realTimeData.congestTolllLength) {
          this.stationCard = {
            cardName: '收费站',
            cardArea: this.realTimeData.congestTollName,
            desc: CongestionUtils.distanceBeautifyNum(
              this.realTimeData.congestTolllLength,
              'm',
              true
            ),
            color: '#415886',
            bgColor: '#f2f2f2',
            linksType: 10
          };
        } else {
          this.stationCard = {};
        }
        this.congestionCards = [
          this.areaCard,
          this.roadCards,
          this.scenicCard,
          this.tradeCard,
          this.highCard,
          this.stationCard
        ].filter((item) => Object.keys(item).length > 0);
      }
    },
    // 跳转交通号首页
    goSituationLink() {
      const { pageType, type, unitId } = this.logParams;
      log.log('card_click', { page_type: pageType, type, album_id: unitId });
      const url = new URL('https://jiaotonghao2.amap.com?channel=amap&src=h5_lbp_push');
      const { searchParams } = url;
      searchParams.append('unitId', this.unitId);
      jumpHandler(url, { needSchema: !!webviewInfo.isInAmap(), hideTitleBar: true });
    },
    // 跳转交通号首页
    goEarlyWarningLink() {
      const { pageType, type, unitId } = this.logParams;
      log.log('card_click', { page_type: pageType, type, album_id: unitId });
      const url = new URL('https://jiaotonghao2.amap.com?channel=amap&src=h5_lbp_push');
      const { searchParams } = url;
      searchParams.append('unitId', this.unitId);
      jumpHandler(url, { needSchema: !!webviewInfo.isInAmap(), hideTitleBar: true });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../common/css/common-mixin";
.situation-warp {
  padding: rpx(24) rpx(24) rpx(14);
  background: #fafafa;
  border-radius: rpx(24);
  opacity: 0;
  visibility: hidden;
  &.show {
    opacity: 1;
    visibility: visible;
  }
  &-title {
    font-size: rpx(32);
    color: rgba(0, 0, 0, 0.9);
    font-weight: bold;
  }
  .situation-update-time {
    font-size: rpx(24);
    color: rgba(0, 0, 0, 0.4);
    font-weight: normal;
  }
  .situation-info {
    margin: 0 0 rpx(6);
    > div {
      background: #f2f2f2;
      border-radius: rpx(8);
    }
    &-idx,
    &-point,
    &-mileage,
    &-station,
    &-wall {
      padding: rpx(15) 0 rpx(13);
      font-size: rpx(24);
      color: rgba(0, 0, 0, 0.6);
      font-weight: normal;
      text-align: center;
    }
    &-idx,
    &-point {
      width: calc(50% - 0.04rem);
    }
    &-idx,
    &-mileage,
    &-station {
      margin-right: rpx(8);
    }
    &-station-other {
      margin-right: 0;
    }
    &-mileage,
    &-station,
    &-wall {
      width: calc(33.33333333% - 0.055rem);
    }
    &-mileage-other,
    &-station-other {
      width: calc(50% - 0.04rem);
      margin-top: rpx(8);
    }
    .info-idx,
    .info-point,
    .info-mileage,
    .info-station,
    .info-wall {
      height: rpx(64);
      font-size: rpx(64);
      color: rgba(0, 0, 0, 0.9);
      line-height: rpx(56);
    }
    .info-point {
      color: rgba(0, 0, 0, 0.9);
    }
    .info-idx,
    .info-mileage {
      position: relative;
      .iconfont {
        font-size: rpx(24);
        margin-left: rpx(5);
        position: absolute;
        top: rpx(12);
      }
    }
    .info-idx-text {
    }
  }
  .congestion-item:nth-child(even) {
    padding-left: rpx(24);
  }
}

.map-container {
  margin-top: rpx(12);
  margin-bottom: rpx(8);
  position: relative;
  width: rpx(670);
  height: rpx(320);
  border-radius: rpx(8);
  overflow: hidden;
  background-color: #f2f2f2;
  .map-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
  }
}
</style>
